document.addEventListener('DOMContentLoaded', function () {
  let productInfoData = localStorage.getItem('fdrproductinfo');

  if (productInfoData !== undefined && productInfoData !== '') {
    let productInfoJson = JSON.parse(productInfoData);
    if (productInfoJson.length > 0) {
      let container = document.querySelector('#fdr-personal-info-request-items');
  
      productInfoJson.forEach((product) => {
        let productDiv = document.createElement('div');
        productDiv.className = `product-item product-item-${product.id}`;
        
        if (product.image) {
          let image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title || 'Product Image';
          productDiv.appendChild(image);
        }
  
        let productInfoDiv = document.createElement('div');
        productInfoDiv.className = 'product-info';
        
let title = document.createElement('div');
title.className = 'product-title';
title.textContent = (product.title || 'No Title').replace(/&/g, '');
productInfoDiv.appendChild(title);

  
        let variantId = document.createElement('div');
        variantId.className = 'product-variant';
        variantId.textContent = `${product.variants || 'N/A'}`;
        productInfoDiv.appendChild(variantId);
  
        let price = document.createElement('div');
        price.className = 'product-price';
        price.textContent = `Price: ${product.price || 'N/A'}`;
        productInfoDiv.appendChild(price);
  
        if (product.custom_note != "") {
          let summary = document.createElement('div');
          summary.className = 'product-summary';
          summary.textContent = `Vision: ${product.custom_note}`;
          productInfoDiv.appendChild(summary);
        }
  
        let uploadCount = product['_cl-upload'].length;
        if (product.hasOwnProperty('properties')) {
          let uploadsDiv = document.createElement('div');
          uploadsDiv.className = 'product-uploads';
          for (let i = 1; i<= uploadCount; i++) {
            let uploadElement = document.createElement('div');
            uploadElement.className = 'product-upload';
            // uploadElement.innerHTML = `<span>upload_${i}</span><a href="${product.properties[`upload_${i}`]}" target="_blank" style="cursor:pointer;border:0;margin-left:8px;">🔗</a>`;
            // uploadElement.innerHTML = `<span>File: </span><a href="${product.properties[`upload_${i}`]}" target="_blank" style="cursor:pointer;border:0;margin-left:8px;">🔗</a>`;
            const fileUrl = product.properties[`upload_${i}`];
          
            const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      
            uploadElement.innerHTML = `<span>File: </span> 
                <a href="${fileUrl}" target="_blank" style="cursor:pointer;border:0;margin-left:8px;">${fileName}</a>`;

            uploadsDiv.appendChild(uploadElement);
          }
          productInfoDiv.appendChild(uploadsDiv);
        }
  
        productDiv.appendChild(productInfoDiv);
  
        let closeBtn = document.createElement('div');
        closeBtn.className = 'close-button';
        closeBtn.setAttribute('data-id', product.id);
        closeBtn.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="currentColor" fill-rule="nonzero"></path>
          </svg>
        `;
        closeBtn.addEventListener('click', (e) => {
          let productVariantId = e.currentTarget.getAttribute('data-id');
          let productItem = document.querySelector(`.product-item-${productVariantId}`);
          container.removeChild(productItem);
  
          let jsonDataStr = localStorage.getItem('fdrproductinfo');
          let jsonData = JSON.parse(jsonDataStr);
          jsonData = jsonData.filter(product => product.id !== productVariantId);
          localStorage.setItem('fdrproductinfo', JSON.stringify(jsonData));
          
          let counterEmpty = document.querySelector(".fdr-counter-section .fdr-counter-icon.counter-empty");
          let counterNotEmpty = document.querySelector(".fdr-counter-section .fdr-counter-icon.counter-not-empty");
          let counterBadge = document.querySelector(".fdr-counter-section .fdr-counter-badge");
          let counterBadgeNumber = document.querySelector(".fdr-counter-section .fdr-counter-badge-number");
  
          if (jsonData.length == 0) {
            counterEmpty.classList.remove('hide');
            counterNotEmpty.classList.add('hide');      
            counterBadge.classList.add('hide');
            counterBadgeNumber.classList.add('hide');   
            counterBadgeNumber.innerHTML = ``;
  
            window.location.href = '/pages/fdr-step-1';
          } else {
            counterEmpty.classList.add('hide');
            counterNotEmpty.classList.remove('hide');
            counterBadge.classList.remove('hide');
            counterBadgeNumber.classList.remove('hide');
            counterBadgeNumber.innerHTML = `${jsonData.length}`;
          }
        });
        productDiv.appendChild(closeBtn);
        
        container.appendChild(productDiv);
      });
    }
  }
});